import React, { Component } from "react";
import commStyles from "../../common/styles";
import { connect } from "react-redux";
import {Container}  from '../../common/components/Container';
import { Table } from "../../common/components/Table";
import { Model } from "../../common/components/Model";
import { ReactSelect } from "../../common/components/ReactSelect";
import apiCall from '../../common/utils/apiCall';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import '../../common/styles/styles.css';
import { FormLabel } from "@mui/material";

const {
  Form,
  FormRow,
  FormColumn,
  FormInput,
  FormInputLabel,
  ButtonWrapper,
  ButtonSecondary,
  ButtonSuccess,
  SubHeading,
  IconWhiteHover,
  StyledDatePicker,
} = commStyles;

const columns = [
  { id: 'name', label: 'Buyer Name', minWidth: '10%' },
  { id: 'email', label: 'Buyer Email', minWidth: '10%' },
  { id: 'number', label: 'Number', minWidth: '10%' },
  { id: 'orderedPrice', label: 'Ordered Price', minWidth: '10%' },
  { id: 'status', label: 'Payment Status', minWidth: '10%' },
  { id: 'reference_id', label: 'Reference Id', minWidth: '10%' },
  { id: 'createdAt', label: 'Order Created On', minWidth: '10%' },
  { id: 'updatedAt', label: 'Order Completed On', minWidth: '10%' },
  { id: 'settingActions', label: 'Actions', minWidth: '10%' },
];

let mountLimit = 1;
let filterHeight = (document.getElementById('filterDiv'))?`${document.getElementById('filterDiv').offsetHeight}px`:'10vh'

class Orders extends Component {

  constructor(props){
    super(props);
    this.state = {
      ordersData : [],
      totalSize : 0,
      rowsPerPage : 20,
      filterOptionsLimit : 20,
      orderInfo : {},

      // NUMBERS FILTER
      numbersFilterInput: '',
      numbersFilterOptions: [],
      numbersFilterLoading: false,

      // EMAIL FILTER
      emailFilterInput: '',
      emailFilterOptions: [],
      emailFilterLoading: false,
      


      portingModelOpen : false,


      filterData : {},
      createData : {},
    }
  }

  async componentDidMount(){
    if (mountLimit == 1){
      mountLimit++;
      try {
        const {result} = await apiCall('REACT_APP_GET_ORDERS', 'POST', {
          limit : this.state.rowsPerPage,
          skip : 0,
        })
        if (result && result['success'] && result['status']){
          let modifyData = await this.modifyApiData(result.status)
          this.setState({ordersData : modifyData, totalSize : await result.totalSize});
          toast.success(result.msg);
        }
      } catch (error) {
        console.log('Orders componentDidMount Error ::', error);
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }

  async modifyApiData(rawDataArray) {
    return await rawDataArray.map( (data) =>{
      data['name']   = [data.firstName, data.lastName].join(' ');
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.updatedAt = new Date(data.updatedAt).toLocaleString();

      return data;
    })
  }


  // FILTER HANDLERS
  handleNumbersInputChange = async (numbersFilterInput, { action }) => {
    this.setState({ numbersFilterLoading: true })
    let input;
    let numbersFilterOptions = []
    if (action === 'set-value') {
      input = this.state.numbersFilterInput
    } else {
      input = numbersFilterInput
      this.setState({ numbersFilterInput })
    }
    if (input.split('').length >= 3){
      const {result} = await apiCall('REACT_APP_GET_ORDERS', 'POST', {
        textToSearch : input,
        limit : this.state.filterOptionsLimit
      })
      if (result && result.success){
        numbersFilterOptions = await this.formatData(result.status, 'numberId', 'number')
      }
    }

    this.setState({ numbersFilterOptions, numbersFilterLoading: false })
  }
  handleEmailInputChange = async (emailFilterInput, { action }) => {
    this.setState({ emailFilterLoading: true })
    let input;
    let emailFilterOptions = []
    if (action === 'set-value') {
      input = this.state.emailFilterInput
    } else {
      input = emailFilterInput
      this.setState({ emailFilterInput })
    }
    if (input.split('').length >= 3){
      const {result} = await apiCall('REACT_APP_GET_ORDERS', 'POST', {
        textToSearch : input,
        limit : this.state.filterOptionsLimit
      })
      if (result && result.success){
        emailFilterOptions = await this.formatData(result.status, 'email', 'email')
      }
    }

    this.setState({ emailFilterOptions, emailFilterLoading: false })
  }
  submitFilter = async (filterData) => {
    Object.keys(filterData).forEach((data)=>{
      if (filterData[data] == [] || filterData[data] == {} || filterData[data] == ''){
        delete filterData[data];
      }
    })
    filterData['skip'] = 0;
    filterData['limit'] = this.state.rowsPerPage || 20;
    const {result} = await apiCall('REACT_APP_GET_ORDERS', 'POST', filterData)
    if (result && result['success'] && result['status']){
      let modifyData = await this.modifyApiData(result.status)
      this.setState({ordersData : modifyData, totalSize : await result.totalSize});
      toast.success(result.msg);
    }
  }

  settingActionsClick = async (data) => {
    this.setState({portingModelOpen : true, createData : {orderId : data.id, upcNumber : (data.upcNumber)?data.upcNumber:"", upcValidity : (data.upcValidity ? new Date(data.upcValidity) : "")}, orderInfo : data});
  }

  submitPortingDetails = async (createData) => {
    Object.keys(createData).forEach((data)=>{
      if (createData[data] == [] || createData[data] == {} || createData[data] == ''){
        delete createData[data];
      }
    })
    if (Object.keys(createData).length == 0){
      return;
    }
    const {result} = await apiCall('REACT_APP_SEND_UPC_MAIL', 'POST', createData)
    if (result && result['success'] && result['status']){
      this.setState({portingModelOpen : false, createData : {}})
      toast.success(result.msg);
      this.componentDidMount();
    }
  }
  
  handleChangePage = async (chnagedPage, rowsPerPage) => {
    let filterData = this.state.filterData;
    let skippedEmptyArrayOfObj = [];
    Object.keys(filterData).forEach((data)=>{
      if (filterData[data] == [] || filterData[data] == {} || filterData[data] == ''){
        delete filterData[data];
      }
    })
    filterData['skip'] = chnagedPage * rowsPerPage || 0;
    filterData['limit'] = rowsPerPage || 20;
    for (let i=0; i<filterData['skip']; i++){
      skippedEmptyArrayOfObj.push({});
    }
    const {result} = await apiCall('REACT_APP_GET_NUMBERS', 'POST', filterData)
    if (result && result['success'] && result['status']){
      let modifyData = await this.modifyApiData(result.status)
      this.setState({numbersData : [...skippedEmptyArrayOfObj, ...modifyData],rowsPerPage : rowsPerPage, totalSize : await result.totalSize});
      return true;
    }
    return false;
  }

  handleChange = async (event, state, stateEdit, stateCreate) => {
    if (!Array.isArray(event)){
      event = [event] 
    }

    if (stateEdit){
      let editData = this.state.editData;
      editData[stateEdit] = []
      await event.forEach( data => editData[stateEdit].push(data.value));
      this.setState({editData})
    } else if (stateCreate){
      let createData = this.state.createData;
      createData[stateCreate] = ''
      await event.forEach( data => createData[stateCreate] = (data.value));
      this.setState({createData})
    }else {
      let filterData = this.state.filterData;
      filterData[state] = []
      await event.forEach( data => filterData[state].push(data.value));
      this.setState({filterData})
    }
  }

  formatData = async (data, value, label) => {
    return await data.map( (eachData) =>{
      let obj = {};
      obj['value'] = eachData[value];
      obj['label'] = eachData[label];
      return obj;
    })
  }

  render() {
    return (
      <React.Fragment>
        <Container
          headerName = "Orders Manager"
          navPosition = "2"
        >
          <div id="filterDiv" style={{
            display : 'flex',
            justifyContent : 'space-between',
            width : '100%',
            minHeight : filterHeight, 
            border : 'none',
          }}>
            <div id="filterSelectDiv1">
              <ReactSelect
                label = {'Numbers'}
                placeholder = {'Select Numbers'}
                inputValue = {this.state.numbersFilterInput}
                onInputChange = {this.handleNumbersInputChange}
                options = {this.state.numbersFilterOptions}
                stateFilterName = {'numberId'}
                onChange = {this.handleChange}
                isLoading = {this.state.numbersFilterLoading}
                isMulti = {true}
              />
              <ReactSelect
                label = {'Email'}
                placeholder = {'Select Email'}
                inputValue = {this.state.emailFilterInput}
                onInputChange = {this.handleEmailInputChange}
                options = {this.state.emailFilterOptions}
                stateFilterName = {'userEmail'}
                onChange = {this.handleChange}
                isLoading = {this.state.emailFilterLoading}
                isMulti = {true}
              />
            </div>
            <div style={{
              display : 'flex',
              flexDirection : 'row',
              gap : '10px',
              alignItems : 'center',
              justifyContent : 'center',
            }}>
              <ButtonSuccess
                style={{
                  display : 'flex',
                  flexDirection : 'row',
                  gap : '5px',
                  alignItems : 'center',
                  height : '28px',
                  padding : '7px 10px'
                }}
                onClick={()=>{this.submitFilter(this.state.filterData)}}
              >
                <span id="filterButtonStyle">FILTER</span>
                <FilterAltIcon sx={{width : '15px'}}/>
              </ButtonSuccess>
              {/* <ButtonSuccess
                style={{
                  display : 'flex',
                  flexDirection : 'row',
                  gap : '5px',
                  alignItems : 'center',
                  height : '28px',
                  padding : '7px 10px'
                }}
                onClick={()=>{this.setState({createData : {},createModelOpen:true})}}
              >
                <span id="filterButtonStyle">CREATE</span>
                <AddCircleIcon sx={{width : '15px'}}/>
              </ButtonSuccess> */}
            </div>
          </div>
          <Table
            columns={columns || []}
            dataValues={this.state.ordersData || []}
            totalSize={this.state.totalSize || 0}
            filterHeight = {filterHeight}
            rowsPerPage = {this.state.rowsPerPage}
            handleChangePage = {this.handleChangePage}
            settingActionsClick = {this.settingActionsClick}
          />
        </Container>

        {/* PORTING EMAIL MODEL */}
        <Model
          title={`UPC MAIL MODEL (${this.state.orderInfo.name || ' '})`}
          modelOpen={this.state.portingModelOpen}
          maxWidth={'300px'}
        >
          <Form>
            {
              this.state.orderInfo.upcMailSendDate
              ? <FormLabel>UPC mail is already send on {new Date(this.state.orderInfo.upcMailSendDate).toLocaleString()}</FormLabel>
              : ''
            }
            <FormColumn>
              <FormLabel>upc number</FormLabel>
              <FormInput
                type="text"
                required={true}
                value={this.state.createData['upcNumber']}
                placeholder="Enter UPC"
                onChange={(e)=>{this.handleChange(e.target,'','','upcNumber')}}
              ></FormInput>
              <FormLabel>upc validity</FormLabel>
              <StyledDatePicker
                selected={this.state.createData['upcValidity']}
                placeholderText={"Select Validity"}
                onChange={(date)=>{this.handleChange([{value : new Date(date)}],'','','upcValidity')}}
                showTimeSelect
                dateFormat="Pp"
              />
            </FormColumn>
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={
                  '/admin/orders'
                }
              >
                <ButtonSecondary onClick={()=>{this.setState({portingModelOpen:false, createData : {}})}}>
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={
                  '/admin/orders'
                }
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={()=>{this.submitPortingDetails(this.state.createData)}}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>
      </React.Fragment>
    );
  }

}

const mapStateToProps = (state) => {
  return { state }
}

export default connect(mapStateToProps)(Orders);
